import { SystemEnum, MenuEnum } from "./enum"

// 导航默认路由
// export const DefaultNavPath = '/document/domainList'
export const DefaultNavPath = '/indicator/englist'

// 面包屑配置。没有配置就不展示
export const BreadcrumbNameMap: Record<string, string> = {
  // 指标
  '/indicator': MenuEnum.ZJZB,
  '/indicator/englist': '指标工程',
  '/indicator/operlog': '操作日志',
  // '/indicator/application': '指标报表',
  // '/indicator/report': '指标报表',
  '/indicator-apply/application': '指标报表',
  '/indicator-apply/report': '指标报表',
  '/indicator/englist/edit': '指标工程',
  // '/indicator/list': '指标项目列表',
  '/indicator/edit': '编辑',
  // '/indicator/reviewList': '待审核指标列表',
  '/indicator/examine': '审核',
  '/baseInfo': '基本信息',
  // '/inventory': '清单',
  // '/inventory/setIndicator': '设置指标',
  // 指标采集
  '/indicator/collectorTemplate': '指标模板',
  '/indicator/collectorTemplate/edit': '模板编辑',
  '/indicator/officialTemplate': '报表模板',
  '/indicator/officialTemplate2': '报表模板',
  '/indicator/official-template/open': '报表模板开放',
  '/indicator/official-template/setting': '报表模板设置',
  '/indicator/official-template/newSetting': '报表模板设置',
  '/indicator/contractTemplate': '合约模板',
  '/indicator/contractTemplate/edit': '模板编辑',
  // 简报看板
  '/indicator-brief': MenuEnum.ZJZB,
  '/indicator-brief/summary': '简报看板',
  // 指标查询
  '/indicator-view': MenuEnum.ZJZB,
  '/indicator-view/km': '科目指标',
  '/indicator-view/eng': '工程指标',
  '/indicator-view/qdzhdj': '清单综合单价',
  '/indicator-view/glj': '工料机价格',
  // 指标应用
  '/indicator-apply': MenuEnum.ZJZB,
  '/indicator-apply/costControlCompare': '费控对比',
  '/investment': MenuEnum.ZJZB,
  '/investment/estimate': '投资估算',
  '/investment/estimate/edit': '估算详情',
  '/indicator-apply/costControlCompare/edit': '对比设置',
  '/indicator-apply/costControlCompare/result': '对比结果',
  '/indicator-apply/standard': '指标标准',
  '/indicator-apply/standard/edit': '标准编辑',

  // 成本管控
  '/cost-control': MenuEnum.ZJZB,
  // '/contract': MenuEnum.ZJZB,
  '/cost-control/contract-plan': '合约规划',
  '/cost-control/contract-plan/edit': '合约规划编辑',

  // 鲁班数据
  '/inventory': MenuEnum.SYSTEM,
  '/inventory/list': '清单库',
  '/inventory/ration': '定额库',
  '/inventory/laborMaterialsMachinery': '人材机库',
  '/zjDict': MenuEnum.ZJZB,
  '/zjDict/info3': '工程信息',
  '/zjDict/subjectAttr': '科目属性',
  '/systemData': MenuEnum.ZJZB,
  '/systemData/glj': '系统工料机',
  '/systemData/unit': '系统单位',
  '/systemData/unitChange': '单位转换',
  '/systemData/collectTemplateRules': '指标模板规则',
  '/systemData/collectTemplateRules/edit': '规则编辑',
  // 字典
  '/systemDict': MenuEnum.SYSTEM,
  '/systemDict/feature': '工程特征',
  '/systemDict/feature2': '工程特征',
  '/systemDict/projectSpecial': '工程专业',
  '/systemDict/projectStep': '项目阶段',
  '/systemDict/info': '项目信息',
  '/systemDict/info2': '项目信息',
  '/systemDict/info3': '指标工程信息',
  '/systemDict/projectCategory': '工程分类',
  '/zjDict/indicatorStandard': '指标标准',
  '/zjDict/costingPhase': '造价阶段',
  '/zjDict/gsgc': '估算工程信息',

  // 系统设置
  '/zj-system': MenuEnum.ZJZB,
  '/zj-system/allocationRules': '分摊规则',
  '/zj-system/verifySetting': '校验设置',
  '/zj-system/fee-standard': '费率标准',
  '/zj-system/fee-standard/edit': '费率标准',
  '/zj-system/adjust-factor': '调整因子',


  // 租户字典
  '/dict': MenuEnum.SYSTEM,
  '/dict/feature': '工程特征',
  '/dict/feature2': '工程特征',
  '/dict/projectSpecial': '工程专业',
  '/dict/projectStep': '项目阶段',
  '/dict/info': '项目信息',
  '/dict/info2': '项目信息',
  '/dict/projectCategory': '工程分类',

  // 项目中心
  '/project-center': MenuEnum.SYSTEM,
  '/project-center/list': '项目列表',
  // '/project-center/englist': '指标工程',

  // 项目业绩
  '/cloud-project': MenuEnum.XMYJ,
  '/cloud-project/list': '项目列表',
  '/cloud-project/document-list': '资料列表',
  '/cloud-project/analysis': '统计分析',
  '/template': MenuEnum.XMYJ,
  '/template/list': '项目模板',
  '/cloud-project/dict-list': '数据字典',
  '/cloud-project/code-rule': '编码规则',
  '/cloud-project/base-partner': '合作单位',
  '/field': MenuEnum.XMYJ,
  '/field/list': '字段设置',

  // 量价协同
  '/cost': MenuEnum.LJXT,
  '/cost/list': '成本科目库',
  '/cost/split': '自动拆分方案',

  // 资料文档
  '/document': MenuEnum.ZLWD,
  '/document/engList': '资料工程',
  '/document/engList/detail': '资料工程详情',
  '/document/engList/dir': '资料工程目录',
  '/document/enterpriseInfo': '企业信息',
  '/document/personInfo': '人员信息',
  '/document/domainList': '字段域',
  '/document/templateList': '文档模板',
  '/document/dirList': '文档目录',
  '/document/packageTemplateList': '资料包模板',
  '/document/packageTemplateList/view': '资料包视图',
  '/document/engDict': '工程类型',
  '/document/projectInfoDict': '项目属性',
  '/document/enterpriseInfoDict': '企业属性',
  '/document/personInfoDict': '人员属性',
  '/document/signDict': '签名身份',

  // 上海燃气-申燃宝
  '/shry': MenuEnum.SHRY,
  '/shry/list': '物料库',
  '/shry/fee-standard': '费率标准',
  '/shry/unit-price-standard': '单价标准',
  '/shry/unit-price-standard/edit': '单价标准编辑',
  '/shry/project-standard': '标准化项目',
  '/shry/project-standard/edit': '标准化项目编辑',
}

export enum HeaderMenuEnum {
  zyzx = 'zyzx', // 作业中心
  szzc = 'szzc', // 数字资产
  jcsj = 'jcsj', // 基础数据

  xmyj = 'xmyj', // 项目业绩
  zjzb = 'zjzb', // 造价指标
}



// header 点击和默认路径配置
export const HeaderPathMap = {
  [HeaderMenuEnum.zyzx]: '/cloud-project/list',
  [HeaderMenuEnum.szzc]: '/indicator/list',
  [HeaderMenuEnum.jcsj]: '/template/list',

  [HeaderMenuEnum.xmyj]: '/cloud-project/list',
  // [HeaderMenuEnum.zjzb]: '/project-center/englist',
  [HeaderMenuEnum.zjzb]: '/indicator/englist',


}

// 默认顶部菜单key值
export const DefaultSystemKey = SystemEnum.SYSTEM

// 菜单默认打开key
export const DefaultOpenKeys = 'indicator'

// 菜单高亮 {当前路由：(菜单url|菜单key)}
export const SelectedKeysMap = {
  '/indicator-brief/summary': '/indicator-brief/summary',
  '/indicator/englist': '/indicator/englist',
  '/indicator/operlog': '/indicator/operlog',
  '/indicator-apply/application': '/indicator-apply/application',
  '/indicator/englist/edit': '/indicator/englist',
  '/indicator/list': '/indicator/list',
  '/indicator/add': '/indicator/list',
  '/indicator/edit': '/indicator/list',
  '/indicator/detail': '/indicator/list',
  '/indicator/multicompare': '/indicator/list',
  '/indicator/singlecompare': '/indicator/list',
  '/indicator/reviewList': '/indicator/reviewList',
  '/indicator/examine': '/indicator/reviewList',
  '/indicator/viewExamine': '/indicator/reviewList',
  '/indicator/reviewSingle': '/indicator/reviewList',
  '/indicator/reviewMulti': '/indicator/reviewList',
  '/indicator-apply/report': '/indicator-apply/report',

  '/indicator/collectorTemplate': '/indicator/collectorTemplate',
  '/indicator/collectorTemplate/edit': '/indicator/collectorTemplate',
  '/indicator/officialTemplate': '/indicator/officialTemplate',
  '/indicator/officialTemplate2': '/indicator/officialTemplate2',
  '/indicator/official-template/open': '/indicator/officialTemplate',
  '/indicator/official-template/setting': '/indicator/officialTemplate',
  '/indicator/contractTemplate': '/indicator/contractTemplate',
  '/indicator/contractTemplate/edit': '/indicator/contractTemplate',
  '/zjDict/info3': '/zjDict/info3',
  '/zjDict/gsgc': '/zjDict/gsgc',
  '/zjDict/subjectAttr': '/zjDict/subjectAttr',
  '/zjDict/indicatorStandard': '/zjDict/indicatorStandard',
  '/zjDict/costingPhase': '/zjDict/costingPhase',
  '/zjDict/invoiceType': '/zjDict/invoiceType',
  '/systemData/glj': '/systemData/glj',
  '/systemData/unit': '/systemData/unit',
  '/systemData/unitChange': '/systemData/unitChange',
  '/systemData/collectTemplateRules': '/systemData/collectTemplateRules',
  '/systemData/collectTemplateRules/edit': '/systemData/collectTemplateRules',
  '/enterprise/project': '/enterprise/project',
  '/enterprise/single': '/enterprise/single',
  '/enterprise/unit': '/enterprise/unit',
  '/enterprise/inventory': '/enterprise/inventory',
  '/enterprise/material': '/enterprise/material',

  '/zj-system/allocationRules': '/zj-system/allocationRules',
  '/zj-system/verifySetting': '/zj-system/verifySetting',
  '/zj-system/fee-standard': '/zj-system/fee-standard',
  '/zj-system/fee-standard/edit': '/zj-system/fee-standard',
  '/zj-system/adjust-factor': '/zj-system/adjust-factor',

  '/systemDict/feature': '/systemDict/feature',
  '/systemDict/feature2': '/systemDict/feature2',
  '/systemDict/projectSpecial': '/systemDict/projectSpecial',
  '/systemDict/projectStep': '/systemDict/projectStep',
  '/systemDict/info': '/systemDict/info',
  '/systemDict/info2': '/systemDict/info2',
  '/systemDict/info3': '/systemDict/info3',
  '/cloud-project/dict-list': '/cloud-project/dict-list',
  '/cloud-project/code-rule': '/cloud-project/code-rule',
  '/cloud-project/base-partner': '/cloud-project/base-partner',
  '/systemDict/projectCategory': '/systemDict/projectCategory',
  '/systemDict/project': '/systemDict/project',
  '/systemDict/sort': '/systemDict/sort',
  '/systemDict/template': '/systemDict/template',
  '/systemDict/professional': '/systemDict/professional',
  '/systemDict/total': '/systemDict/total',
  '/systemDict/type': '/systemDict/type',
  '/systemDict/baseDict': '/systemDict/baseDict',


  '/dict/feature': '/dict/feature',
  '/dict/feature2': '/dict/feature2',
  '/dict/projectSpecial': '/dict/projectSpecial',
  '/dict/projectStep': '/dict/projectStep',
  '/dict/info': '/dict/info',
  '/dict/info2': '/dict/info2',
  '/dict/projectCategory': '/dict/projectCategory',
  '/dict/project': '/dict/project',
  '/dict/sort': '/dict/sort',
  '/dict/template': '/dict/template',
  '/dict/professional': '/dict/professional',
  '/dict/total': '/dict/total',
  '/dict/type': '/dict/type',
  '/dict/baseDict': '/dict/baseDict',

  '/inventory/list': '/inventory/list',
  '/inventory/ration': '/inventory/ration',
  '/inventory/laborMaterialsMachinery': '/inventory/laborMaterialsMachinery',
  '/cost/list': '/cost/list',
  '/cost/split': '/cost/split',
  '/register': '/register',
  '/template/list': '/template/list',
  '/field/list': '/field/list',
  '/cloud-project/list': '/cloud-project/list',
  '/cloud-project/document-list': '/cloud-project/document-list',
  '/cloud-project/analysis': '/cloud-project/analysis',
  '/cloudProject/list': '/cloudProject/list',
  // '/official-template/list': '/official-template/list',
  // '/official-template/open': '/official-template/list',
  // '/official-template/setting': '/official-template/list',
  '/project-center/list': '/project-center/list',
  '/project-center/englist': '/project-center/englist',
  '/project-center/englist/edit': '/project-center/englist',
  '/official-template/list': '/official-template/list',
  '/official-template/open': '/official-template/list',
  '/official-template/setting': '/official-template/list',
  '/log/list': '/log/list',

  '/indicator-view/km': '/indicator-view/km',
  '/indicator-view/eng': '/indicator-view/eng',
  '/indicator-view/qdzhdj': '/indicator-view/qdzhdj',
  '/indicator-view/glj': '/indicator-view/glj',
  // '/standard/edit':'standard/edit',
  '/indicator-apply/costControlCompare': '/indicator-apply/costControlCompare',
  '/indicator-apply/costControlCompare/edit': '/indicator-apply/costControlCompare',
  '/indicator-apply/costControlCompare/result': '/indicator-apply/costControlCompare',
  '/investment/estimate': '/investment/estimate',
  '/investment/estimate/edit': '/investment/estimate',
  '/indicator-apply/standard': '/indicator-apply/standard',
  '/indicator-apply/standard/edit': '/indicator-apply/standard',

  '/cost-control/contract-plan': '/cost-control/contract-plan',
  '/cost-control/contract-plan/edit': '/cost-control/contract-plan/edit',

  // 资料文档
  '/document/engList': '/document/engList',
  '/document/engList/detail': '/document/engList',
  '/document/engList/dir': '/document/engList',
  '/document/enterpriseInfo': '/document/enterpriseInfo',
  '/document/personInfo': '/document/personInfo',
  '/document/domainList': '/document/domainList',
  '/document/templateList': '/document/templateList',
  '/document/dirList': '/document/dirList',
  '/document/packageTemplateList': '/document/packageTemplateList',
  '/document/packageTemplateList/view': '/document/packageTemplateList',
  // 字典信息
  '/document/engDict': '/document/engDict',
  '/document/projectInfoDict': '/document/projectInfoDict',
  '/document/enterpriseInfoDict': '/document/enterpriseInfoDict',
  '/document/personInfoDict': '/document/personInfoDict',
  '/document/signDict': '/document/signDict',

  // 上海燃气
  '/shry/list': '/shry/list',
  '/shry/fee-standard': '/shry/fee-standard',
  '/shry/unit-price-standard': '/shry/unit-price-standard',
  '/shry/unit-price-standard/edit': '/shry/unit-price-standard',
  '/shry/project-standard': '/shry/project-standard',
  '/shry/project-standard/edit': '/shry/project-standard',
}

// 侧边栏宽度
export const SliderWidth = '228px'

// 列表默认展示多少条数据
export const tableListDefaultPageSize = 15
// 导航菜单高度
export const HeightHeader = 64
// 面包屑高度
export const HeightBreadcrumb = 38
